// CUBBO-2182: the SIP "next order" button advances within the SAME product
// (batch packing of identical units). It tells the backend which product to
// keep packing via `find_in_sip_siblings_by_product`, which matches a picking
// order on `product_codes.sku` OR `products.bar_code`.
//
// The previous code sent only `product.bar_code`. For products without a
// bar_code (SKU-only, identified through `product_codes`) that value is null,
// so the backend saw a blank `product_upc_sku`, dropped the SKU filter, and
// silently advanced CROSS-SKU to a different product — skipping the scan
// verification the dead-end fix was built to preserve. Fall back to the
// product's SKU so the advance stays SKU-scoped; when the SKU is exhausted the
// backend returns 404 and the front routes back to the tote product scan.
export const resolveSipProductIdentifier = (orderLine) => {
    const product = orderLine?.product
    if (!product) return null

    return product.bar_code || product.product_codes?.[0]?.sku || null
}

// A business-rule insert the picker never fetched: generated, not scannable and
// holding no stock units. Mirrors OrderLine#unpicked_insert? in platform.
const isUnpickedInsert = (orderLine) =>
    Boolean(orderLine?.generated) && !orderLine?.product?.is_scannable && !(orderLine?.stock_units?.length > 0)

// The line the SIP picker took to the tote, resolved the way
// Order#single_item_picking_order_line does it: the lowest id among lines that
// are neither dropshipping nor an unpicked insert. The lines arrive in no fixed
// order, and a store insert listed first would send the insert's code, which the
// sibling lookup no longer matches (404, back to the tote scan). Falls back to
// the first line so the advance never loses its SKU filter.
export const resolveSipOrderLine = (orderLines = []) => {
    const picked = orderLines
        .filter(orderLine => orderLine?.product?.is_dropshipping !== true && !isUnpickedInsert(orderLine))
        .reduce((lowest, orderLine) => (!lowest || orderLine.id < lowest.id ? orderLine : lowest), null)

    return picked || orderLines[0]
}
